import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { utility } from '../../utility';
import { UserListSearchCondition } from './UserListSearchCondition';
import { UserListSearchResult } from './UserListSearchResult';

/**
 * UserList Page Component
 */
const UserList = () => {

  // 2024.5.8 MyMine Version1.5対応 Add Start
  const inputCondition = {
    userId: "",
    userName: "",
    companyId: "",
    roleId: "",
    statusId: "",
  };
  // 2024.5.8 MyMine Version1.5対応 Add End

  const screenId = 'MyM203';

  const [userList, setUserList] = useState(null);
  // 2024.5.8 MyMine Version1.5対応 Modify Start
  const { screenSettings } = useWebContext(screenId);
  // 2024.5.8 MyMine Version1.5対応 Modify End

  const apiRequest = useMyMApi(screenId);
  const [sortModel, setSortModel] = useState([]);

  // 2024.5.8 MyMine Version1.5対応 Add Start
  const [searchCondition, setSearchCondition] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [isSearch, setIsSearch] = useState(false);
  const [isUserListLoading, setIsUserListLoading] = useState(true);
  const [searchInputCondition, setSearchInputCondition] = useState(inputCondition);
  const [searchedInputCondition, setSearchedInputCondition] = useState(inputCondition);
  // 2024.5.8 MyMine Version1.5対応 Add End

  /**
   * ユーザ情報取得成功コールバック処理
   * @param {any} result
   */
  // 2024.5.8 MyMine Version1.5対応 Modify Start
  const callbackUserList = (result) => {
    setUserList(result.Result);
    setSearchCondition(result.Condition)
    setIsUserListLoading(false);
  }
  // 2024.5.8 MyMine Version1.5対応 Modify End

  /**
   * ユーザ情報取得失敗コールバック処理 */
  const callbackFailed = () => {
    setUserList([]);
    setIsUserListLoading(false);
    // 2024.5.8 MyMine Version1.5対応 Add Start
    setSearchCondition([])
    // 2024.5.8 MyMine Version1.5対応 Add End
  }

  /** 初期表示時 */
  useEffect(() => {
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    apiRequest.requestJson(`api/user-info/load-list?LimitMaxRowCount=${screenSettings.MaxRowCount}`, 'GET', callbackUserList, callbackFailed);
    // 2024.5.8 MyMine Version1.5対応 Modify End
  }, []);

  useEffect(() => {
    if (userList === null) return;
    requestSearch();
  }, [pageNumber, sortModel]);

  // 2024.5.8 MyMine Version1.5対応 Add Start
  /**
  * 検索処理
  */
  const requestSearch = () => {
    setIsUserListLoading(true);
    const callbackUserListSuccessContext = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (pageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(pageNumber - 1);
        return;
      }
      setUserList(result);
      setIsUserListLoading(false);
    }
    const callbackUserListFaildContext = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsUserListLoading(false);
    }
    let condition
    if (isSearch) {
      // 検索の場合、現在のフォームの状態で検索をし検索条件を退避
      condition = searchInputCondition;
      setSearchedInputCondition({ ...searchInputCondition })
    } else {
      // ソート・ページングの場合、過去の検索条件を元に検索する
      condition = searchedInputCondition;
    }
    let queryParameters = { ...condition };
    let sortItem = '';
    if (sortModel[0]) {

      switch (sortModel[0].field) {
        case 'USER_ID':
        case 'USER_NAME':
        case 'LAST_LOGIN_DATE':
          sortItem = sortModel[0].field + ' ';
          break;
        case 'COMPANY_NAME_DISP':
          sortItem = 'COMPANY_ORDER_NO ';
          break;
        case 'ROLE_NAME':
          sortItem = 'ROLE_ORDER_NO ';
          break;
        default:
          sortItem = 'STATUS_ORDER_NO ';
          break;
      }

      sortItem += sortModel[0].sort
      queryParameters.SortItems = sortItem;
    }

    queryParameters.PageNumber = pageNumber;
    queryParameters.LimitMaxRowCount = screenSettings.MaxRowCount;

    apiRequest.requestJson(`api/user-info/search-list?${utility.makeEncodeParameter(queryParameters)}`, 'GET', callbackUserListSuccessContext, callbackUserListFaildContext);
    setIsSearch(false);
  };
  // 2024.5.8 MyMine Version1.5対応 Add End

  if (userList === null)
    return <MyMProgress />

  // 2024.5.8 MyMine Version1.5対応 Modify Start
  return (
    <Box style={{ width: '100%', height: '90%' }}>
      <UserListSearchCondition
        screenId={screenId}
        searchCondition={searchCondition}
        searchInputCondition={searchInputCondition}
        setSearchInputCondition={setSearchInputCondition}
        setSortModel={setSortModel}
        setPageNumber={setPageNumber}
        setIsSearch={setIsSearch}
      />
      <UserListSearchResult
        screenId={screenId}
        userList={userList}
        sortModel={sortModel}
        setSortModel={setSortModel}
        isUserListLoading={isUserListLoading}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
    </Box>
  );
}
export default UserList;